import { LoadingOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import WfRunsTable from './WfRunsTable';

const Publishing = ({
  campaign,
  campaignWorkflowRuns,
  tsCampaignsReport,
  tsCampaignsStatus,
  failedToFetchStatus,
  accountTransactions,
  cloneCampaign,
  getCampaignWorkflowRuns,
  getTsCampaignsStatus,
  cloneCampaignLoading,
  fetchCampaignWorkflowRunsLoading,
  fetchTsCampaignsLoading,
  setPublishCampaignDrawerVisible,
  editTSCampaignWeight,
  editWeightLoading,
  doneEditingWeight,
  toggleTSCampaign,
  toggleTSCampaignLoading,
  shouldRefreshTable,
  setShouldRefreshTable,
}) => {
  useEffect(() => {
    getCampaignWorkflowRuns();
  }, [campaign._id]); //eslint-disable-line

  const campaignId = campaign?._id;

  const loadingIcon = <LoadingOutlined spin />;

  const loading = fetchCampaignWorkflowRunsLoading || fetchTsCampaignsLoading;

  return (
    <>
      {campaignId ? (
        <div style={{ textAlign: 'right' }}>
          {Object.keys(tsCampaignsStatus)?.length > 0 ? (
            <Button
              loading={loading}
              onClick={() => setShouldRefreshTable(true)}
              type="primary"
              data-test="refresh-table-button"
              style={{ marginBottom: 20, marginRight: 20 }}
            >
              Refresh Table
            </Button>
          ) : (
            ''
          )}

          <Button
            onClick={() => setPublishCampaignDrawerVisible(true)}
            type="primary"
            data-test="open-publish-button"
            style={{ marginBottom: 20 }}
          >
            Publish Campaign
          </Button>
        </div>
      ) : (
        ''
      )}

      {loading ? (
        <Spin indicator={loadingIcon} style={{ width: '100%', margin: 10 }} />
      ) : (
        campaignWorkflowRuns?.length > 0 && (
          <WfRunsTable
            campaign={campaign}
            campaignWorkflowRuns={campaignWorkflowRuns}
            tsCampaignsReport={tsCampaignsReport}
            accountTransactions={accountTransactions}
            cloneCampaign={cloneCampaign}
            cloneCampaignLoading={cloneCampaignLoading}
            editTSCampaignWeight={editTSCampaignWeight}
            editWeightLoading={editWeightLoading}
            doneEditingWeight={doneEditingWeight}
            toggleTSCampaign={toggleTSCampaign}
            toggleTSCampaignLoading={toggleTSCampaignLoading}
            getTsCampaignsStatus={getTsCampaignsStatus}
            tsCampaignsStatus={tsCampaignsStatus}
            failedToFetchStatus={failedToFetchStatus}
            shouldRefreshTable={shouldRefreshTable}
            setShouldRefreshTable={setShouldRefreshTable}
          />
        )
      )}
    </>
  );
};

export default Publishing;
